import { useContext } from 'react';

import { PurchaseJwtContext, SetPurchaseJwtContext } from '../context';

export const usePurchaseJwt = () => useContext(PurchaseJwtContext);
export const useSetPurchaseJwt = () => useContext(SetPurchaseJwtContext)!;